import * as React from 'react';
import { SVGProps } from 'react';

const IconPasteSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M10 2a2 2 0 1 1 4 0h1a1 1 0 0 1 1 1v2H8V3a1 1 0 0 1 1-1h1z" />
    <path d="M5 3h1v17h12V3h1a1 1 0 0 1 1 1v17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
    <path d="M16 9v2H8V9h8zm-2 4H8v2h6v-2z" />
  </svg>
);
export default IconPasteSizeM;
